import { Icon, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { V3_STEPS } from "./steps";

/**
 * The five steps with their names (DEV-1902): done ticked, the current one
 * filled, the rest outlined. A done step can be revisited; nothing ahead of the
 * furthest reachable one is clickable — a gate is not skipped.
 */
export const V3StepIndicator = ({
  current,
  furthest,
  onStep,
}: {
  current: number;
  /** The furthest step the verification allows now. */
  furthest: number;
  onStep: (step: number) => void;
}) => (
  <ol className="flex w-full items-start" aria-label="Add vehicle steps">
    {V3_STEPS.map(({ step, label }, index) => {
      const done = step < current;
      const active = step === current;
      const reachable = step <= furthest && !active;
      return (
        <li key={step} className="relative flex flex-1 flex-col items-center gap-1.5">
          {index > 0 && (
            <span
              aria-hidden
              className={clsx("absolute right-1/2 top-4 h-0.5 w-full -translate-y-1/2", step <= current ? "bg-primary" : "bg-neutral-mid-gray")}
            />
          )}
          <button
            type="button"
            disabled={!reachable}
            onClick={() => onStep(step)}
            aria-current={active ? "step" : undefined}
            className={clsx(
              "relative z-10 flex h-8 w-8 items-center justify-center rounded-full",
              done && "bg-white text-success",
              active && "bg-primary text-white",
              !done && !active && "border-2 border-neutral-mid-gray bg-white text-neutral-dark-gray",
              reachable ? "cursor-pointer" : "cursor-default"
            )}
          >
            {done ? <Icon name="TickCircle" variant="Bold" size={34} /> : <Typography variant="action">{step}</Typography>}
          </button>
          <Typography
            variant="small"
            className={clsx("text-center", active ? "font-semibold text-primary" : done ? "text-neutral-black" : "text-neutral-dark-gray")}
          >
            {label}
          </Typography>
        </li>
      );
    })}
  </ol>
);
